module.exports = __webpack_public_path__ + "img/red-paper-lantern.9e578529.png";